import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["width", "height", "color"];
import React from 'react';
var CheckIcon = function CheckIcon(_ref) {
  var width = _ref.width,
    height = _ref.height,
    color = _ref.color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: width || '12',
    height: height || '9',
    viewBox: "0 0 12 9"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: color || '#FFF',
    fillRule: "nonzero",
    d: "M10.293.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L4 6.586 10.293.293z"
  }));
};
export default CheckIcon;